// extracted by mini-css-extract-plugin
export default {"imagesCard":"styles_imagesCard__zUg71"};